export interface IAccountMigration {
  accountId: string;
  createdAt: string;
  finishedAt: string;
  id: string;
  logStream: string;
  proAccountId: string;
  sectionId: string;
  status: string;
  type: string;
  statusReason?: string;
  logStreamUrl?: string;
}

export interface IMigration {
  oneAccountId: string;
  order: IMigrationOrder;
  proAccountId: string;
  proAccountName?: string;
  sectionId: string;
  status: string;
  statusLastUpdatedTime: number;
  lastSyncTime?: number;
}

export interface IMigrationOrder {
  settings: IMigrationSettings;
  results: IMigrationResults;
}

export interface IMigrationSettings {
  emailChannelID: string;
  emailKeyspaceID: string;
  events: IMigrationEvents;
  periodicSyncEnabled: boolean;
  profiles: IMigrationProfiles;
  smsChannelID: string;
  smsKeyspaceID: string;
  topics: IMigrationTopics[];
}

export interface IMigrationResults {
  optOutAll: IMigrationOptOutSubscribers;
  subscribers: IMigrationOptOutSubscribers;
  subscriptions: ISubscriptionsResultMapTopicIdMap;
}

export interface IMigrationOptOutSubscribers {
  succeeded: number;
  synced: number;
  failed: number;
  initialMigrationTime: string;
  lastSyncTime: string;
}

export interface ISubscriptionsResultMapTopicIdMap {
  [key: string]: ISubscriptionsResultMapProMailingListId;
}

export interface ISubscriptionsResultMapProMailingListId {
  [key: string]: IMigrationSubscriptions;
}

export interface IMigrationSubscriptions {
  failed: number;
  initialMigrationTime: string;
  lastSyncTime: string;
  optOutListFailed: number;
  optOutListInitialMigrated: string;
  optOutListLastSyncTime: string;
  optOutListSucceeded: number;
  optOutListSyncFailed: number;
  optOutListSynced: number;
  succeeded: number;
  synced: number;
}

export interface IMigrationEvents {
  emailClicks: boolean;
  emailOpens: boolean;
  emailSends: boolean;
  emailUnsubscribes: boolean;
  eventsFrom: number;
  periodicEmailClicks: boolean;
  periodicEmailOpens: boolean;
  periodicEmailSends: boolean;
  periodicEmailUnsubscribes: boolean;
}

export interface IMigrationProfiles {
  attributes: IProfileAttribute;
  initialMigrateOptOutAll: boolean;
  periodicSyncChanges: boolean;
  periodicSyncOptOutAll: boolean;
  tags: string[];
}

export interface IProfileAttribute {
  id: string;
  proAttributeName: string;
}

export interface IMigrationTopics {
  assignSmsConsent: boolean;
  id: string;
  initialMigrateOptOutList: boolean;
  periodicSyncNewSubscriptions: boolean;
  periodicSyncOptOutList: boolean;
  proMailingListId: string;
  tags: string[];
  targetId: string;
  wasRemovedFromPro: boolean;
}

export enum MigrationState {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Success = 'SUCCEEDED',
  Running = 'RUNNING',
  InProgress = 'IN_PROGRESS',
  Submitted = 'SUBMITTED',
  Paused = 'PAUSED',
}

export enum MigrationStateText {
  FAILED = 'Failed',
  PENDING = 'Pending',
  SUCCEEDED = 'Succeeded',
  RUNNING = 'Running',
  IN_PROGRESS = 'InProgress',
  SUBMITTED = 'Submitted',
  PAUSED = 'Paused',
}

export interface IMigrationStatus {
  compoundID: string;
  id: string;
  lastUpdate: string;
  migrationEnd: string;
  migrationStart: string;
  migrationState: MigrationState;
  oneAccountID: string;
  proAccountID: number;
  sectionID: number;
  events: MigrationStatusEvents;
}

export interface MigrationStatusEvents {
  totalEvents: number;
  totalSendings: number;
  processedEvents: number;
  processedSendings: number;
  bounceEvent: StatusEvent;
  clickEvent: StatusEvent;
  openEvent: StatusEvent;
  sendEvent: StatusEvent;
  unsubscribeEvent: StatusEvent;
}

export interface StatusEvent {
  processedEvents: number;
  shouldBeProcessed: boolean;
  totalEvents: number;
}
